import React from 'react';
import BusinessUnitRow from './businessUnitRow/index';

const BusinessUnitList = ({
    data,
    width,
    addFavouriteBusinessUnit,
    onBusinessUnitSelect,
    onSaveBusinessUnit,
    onDeleteBusinessUnit,
    showBusinessUnitLoader
}) => {
    return (
        <div className="app-main-content">
            {data.map((data, index) => <BusinessUnitRow key={index} businessUnit={data}
                    width={width}
                    onDeleteBusinessUnit={onDeleteBusinessUnit}
                    onSaveBusinessUnit={onSaveBusinessUnit}
                    showBusinessUnitLoader={showBusinessUnitLoader}
                    addFavouriteBusinessUnit={addFavouriteBusinessUnit}
                    onBusinessUnitSelect={onBusinessUnitSelect}
                />
            )}
        </div>
    );
};

export default BusinessUnitList;


// WEBPACK FOOTER //
// ./components/Agile/businessUnit/businessUnitList/index.js